import './App.css';
import React from 'react';
import { Route,Routes } from 'react-router-dom';
import Home from './Home/Home';
import Navbar from './Navbar'
import Appointment from './Appointment'
import AdminAppointment from './AddAppointment';
import About from './About';

function App() {
  return (
    <>
      <Navbar/>
      <div style={{paddingTop:"120px"}}>
      <Routes>
          <Route exact path="/" element={<Appointment/>}/>
          <Route path="/adminappointment" element={<AdminAppointment />} />
          <Route path="/about" element={<About />} />
      </Routes>
      </div>
    </>
  );
}

export default App;
